<div class="period-navigator-container-parent">
  <ws-button (click)="decrementDateClicked()" class="changeButton decrementButton">
    <mat-icon>arrow_back_ios_new</mat-icon>
  </ws-button>

  <div class="period-navigator-container selectedDateTitle">
      {{ formatPeriod() }}
  </div>

  <ws-button (click)="incrementDateClicked()" class="changeButton incrementButton">
    <mat-icon>arrow_forward_ios_new</mat-icon>
  </ws-button>
</div>